<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="auth-flow-title" i18n>Sign In</div>

  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email</label>
      <app-email-input
        #emailInput
        formControlName="email"
        controlId="email"
        [error]="formSubmitted && formGroup.controls.email.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.email.invalid"
        [errors]="formGroup.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'password'" i18n>Password</label>
      <app-password-input
        formControlName="password"
        controlId="password"
        (keydown.enter)="signIn()"
        [error]="(formSubmitted && formGroup.controls.password.invalid) || ((signInFailed$ | async) ?? false)" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.password.invalid"
        [errors]="formGroup.controls.password.errors"
        [customErrorMessages]="customErrorMessages.password" />
    </div>
  </div>

  <app-button class="w-100" i18n [type]="ButtonTypeEnum.primary" (buttonClick)="signIn()">Sign In</app-button>
  <div class="d-flex align-items-start">
    <button class="paddingless-text-button mt-2" (click)="forgotPassword()" i18n>Forgot Password</button>
  </div>
</div>
